interface State {
  readonly mode: 'percentage' | 'absolute';
}
export type { State as FavoritesBarState };

export const INITIAL_STATE: State = {
  mode: 'percentage',
};
